<style src="@/assets/css/common.css" scoped></style>
<style>
html, body { 
    width: 100%; 
    height: 100%; 
}
.info-container {
    border: 3px solid black;
    border-radius: 10px;
}

.inline-container {
    /*display: flex;*/
	border-radius: 10px;
	border: 1px solid #000000;
	padding: 20px; 	
}
.inline-container-header{
	border: 2px solid #000000;
	border-radius: 5px;
	padding: 5px; 
}
.place_holder {
    width: 100%;
	height:50px;
}

#viewport {
}

.hot-cluster-button {
    width: 100%; 
    margin: 0 40px;
}

.button-group {
    flex-direction: column;
}



.info-holder {
	border-radius: 10px;
	border: 2px solid #000000;
	padding: 10px; 
	margin: 0;
	position: absolute;
	top: 50%;
	left: 50%;
	-ms-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);	

}
.container-scroll-new {
	overflow-x: auto;
	overflow-y: auto;
	width: 100%;
	height: 200px;
}

.scrollable-container{
	overflow-x: auto;
	overflow-y: auto;
}
.geneinfodiv {
	margin-left: auto;
	margin-right: auto;
}
.proteinsnapshot-svg {
	border: #add26b solid 2px;
	border-radius: 15px;
	width: 100%;

}
.circularplot-header {
	font-weight: bold;
}
.circularplot-svg {
	border: #add26b solid 2px;
	border-radius: 15px;
	width: 100%;
}
.moduleplot-svg {
	font-size: 20px;
}
.container-scroll {
    overflow-x: auto;
}
.form-title {
	background-color: #eeeeee;
}
.new-inline-container {
	border: 1px solid #000000;
}
.overflow-dropdown-menu .dropdown-menu{
	overflow-y: auto;
	max-height: 200px;
}
.diffusion-edge-arrowhead {
	fill: #000066;
	opacity: 1;
}
.diffusionEdgeClass {
	stroke: #000066;
	stroke-opacity: 0.2;
}
.diffusionEdgeClass:hover{
	stroke-opacity: 1;
	opacity: 1;
}
.diffusion-node-kcg-class {
	fill: #660000;
}
.diffusion-node-nonkcg-class {
	fill: #006600;
}
//.diffusionEdgeClass:hover .diffusion-edge-arrowhead , 

.tooltip {
  position: absolute;
  background: cornsilk;
  border: 1px solid black;
  border-radius: 3px;
  padding: 2px 4px;
}

</style>
<style scoped>
.rect.rectClass {
	stroke: #000066;
	fill:   #00cc00;
}


.query-form-title {
	background-color: #eeeeee;
	text-align: center;
	padding-top: 5px;
	padding-right: 5px;
	padding-bottom: 5px;
	padding-left: 10px;
	font-weight: bold;

}
.snapshot_canvas {
	width: 100%;
	height: 100%;
}
.advance-options-form {
  border: 1px solid #000000;
	padding-top: 10px;
	padding-right: 10px;
	padding-bottom: 10px;
	padding-left: 10px;
}
.stickytable {
	border: 1px solid #000000;
	overflow:auto;
	padding-right:18px /* Avoid the scroll bar to block the content*/
}
.stickytable table {
	position: relative;
	border-collapse: collapse;
}
.stickytable th {
	background: #eeeeee;
	padding-left: 10px;
	padding-right: 10px;
}
.stickytable td {
	background: #ffffff;
	padding-left: 10px;
	padding-right: 10px;
}
.stickytable th {
	position: sticky;
	top: 0; /* Required for the stickiness */
	z-index:1; /* Ensure that z-index of elements inside the table is smaller than z-index 10 */
}
.stickytable th:first-child {
	position: sticky;
	left: 0; /* Required for the stickiness */
	z-index:2;
}
.stickytable td:first-child {
	position: sticky;
	left: 0; /* Required for the stickiness */
}

.geneinfotable {
    border-collapse:separate;
	table-layout: fixed;
	width: 100%;
    /*border:solid black 1px;*/
	/*border-radius:6px;*/
}
.geneinfotable thead tr th {
    /*background-color: #009879;*/
    /*color: #ffffff;*/
    text-align: center;
	border-bottom: solid 5px;
	border-bottom-color: #d9d9d9;
	font-weight: bold;
	font-family: "Myriad Pro", Myriad, "Liberation Sans", "Nimbus Sans L", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.geneinfotable tbody tr td {
    text-align: center;
	/*
    border-left:solid black 1px;
    border-top:solid black 1px;
	*/
	
}

.clusterinfotable {
    border-collapse:separate;
	width: 100%;
	height:300px;
}
.clusterinfotable tbody tr {
	border-top:solid white 3px;
	background-color:#d7e9b5;
}
.clusterinfotable tbody td {
	padding:20px;
    background-color:#f3f8e9;
	
}
.clusterinfotable tbody td:nth-child(1) {
    text-align: center;
    font-weight: bold;
	background-color:#d7e9b5;
	border-top-left-radius: 10px;
	border-bottom-left-radius: 10px;
}

clusterinfotable tbody tr:last-child td:first-child {
	border: 2px solid orange;
	border-bottom-left-radius: 10px;
	border-radius: 30px;

}

clusterinfotable tbody tr:last-child td:last-child {
	border: 10px solid green;
	border-bottom-right-radius: 10px;
}
.clusterinfotable tbody td:nth-child(2) {
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
}


.not_found {
    text-align: center;
    width: 96%;
    background-color: #f3f8e9;
    height: 150px;
    margin: auto;
    border-radius: 10px;
    vertical-align: middle;
    display: table;
    margin-bottom: 20px;
}
.moduleinfotable {
	z-index: 8;
    border-collapse:separate;
	background-color: white;
	width: 600px;
	font-size:100%;
	line-height: 30px;
	/*
    border:solid black 1px;
	border-radius:6px;
	*/
	
}
.moduleinfotable thead tr {
    background-color: #d7e9b5;
    text-align: center;
	border-bottom: solid 5px;
	border-bottom-color: #d9d9d9;
	font-weight: bold;

	
}
.moduleinfotable tbody tr td {
    text-align: center;
    background-color: #f3f8e9;
	/*
    border-left:solid black 1px;
    border-top:solid black 1px;
	*/
	
}

.geneinfotable2 {
    border-collapse:separate;
	table-layout: fixed;
	width: 100%;
    /*border:solid black 1px;*/
	/*border-radius:6px;*/
}
.geneinfotable2 thead tr th {
    /*background-color: #009879;*/
    /*color: #ffffff;*/
    text-align: center;
	border-bottom: solid 5px;
	border-bottom-color: #d9d9d9;
	font-weight: bold;
	font-family: "Myriad Pro", Myriad, "Liberation Sans", "Nimbus Sans L", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.geneinfotable2 tbody tr td {
    text-align: center;
	/*
    border-left:solid black 1px;
    border-top:solid black 1px;
	*/
	
}


.borderedtable {
		/*border-left: 1px solid black;*/
	/*border: 1px solid black;*/
	z-index:3;
}
.borderedtable thead tr {
	/*border-top: 2px solid black;*/
	/*box-shadow: 0 -1px 0 #000;*/
	/*outline: 1px solid black;*/
	/*border-bottom: 2px solid black*/
}

.borderedtable tbody tr td {
	border-bottom: 1px solid black
}
.borderedtable thead tr th:first-child,
.borderedtable tbody tr td:first-child  {
/*
	width: 6em;
	min-width: 6em;
	max-width: 6em;
	*/
}
.borderedtable thead tr th,
.borderedtable tbody tr td {
	white-space: nowrap;
	text-align: left;
}
.signature-download-link a:link {
	align:right;
	text-decoration: underline;
}
.viewport {
	/*background-color: #d7e9b5;*/
	border: #add26b solid 5px;
	border-radius: 30px;
    position: relative;
    width: 100%;
    height: 90%;
	/*height: 370px;*/
    z-index: 1;
    /*border: 20px solid wheat;*/
    margin: 0px;
    overflow: hidden;
	
}
.viewport-inside {
    width: 100%;
    height: 100%;
}
.viewport-empty {
	background-color: #d7e9b5;
    width: 100%;
    height: 100%;
	vertical-align: middle;
}
.uniprot_selection_tooltip_class{
	background-color: #d7e9b5;
	border-radius: 10px;
	padding: 15px;
	text-align: left;
}
.legend{
	text-align: center;
	margin-left: 10px;
}
</style>
<template>
	<div id="stage" >
		
	<br>
		<b-container style="margin-bottom:300px;">
			<!-- First section: Gene Information -->
			<b-row>
				<div class="sec_header"> 
					Gene Information
				</div>
				<b-col>
				<div class="geneinfodiv">
					<table class="geneinfotable">
					<thead>
						<tr>
							<th>Gene name</th>
							<th>Uniprot ID</th>
							<th>Have 3D cluster</th>
							<th>Have LOF enrichment signal</th>
						</tr>
					</thead>
					<tbody>
					<tr v-for="uniprot_name in this.query_uniprots" :key="uniprot_name">
						<td><a v-bind:href="'https://www.genecards.org/cgi-bin/carddisp.pl?gene=' + uniprotInfoData[uniprot_name]['gene']" class="hyper_link" style="text-decoration: underline;">{{uniprotInfoData[uniprot_name]["gene"]}}</a></td>
						<td><a v-bind:href="'https://www.uniprot.org/uniprotkb/' + uniprotInfoData[uniprot_name]['uniprot'] + '/entry'" class="hyper_link" style="text-decoration: underline;">{{uniprotInfoData[uniprot_name]["uniprot"]}}</a></td>
						<!--<td>{{uniprotInfoData[uniprot_name]["uniprot"]}}</td>-->
						<td>{{uniprotInfoData[uniprot_name]["mis"]}}</td>
						<td>{{uniprotInfoData[uniprot_name]["lof"]}}</td>
					</tr>
					</tbody>
					</table>
				</div>
				<div class="place_holder">
				</div>
				</b-col>
			</b-row>
			<!-- Second section: Cluster Information -->
			<b-row>
				<div class="sec_header"> 
					3D Cluster / LOF Enrichment Signal
				</div>
				<b-col>
					<b-row>
						<b-col cols="6">
							<b-row>
								<b-col>
									<div> <b>Select a 3D cluster or<br>an LOF enrichment signal:</b> </div>
								</b-col>
								<b-col>
									<b-dropdown :text="selectedCluster === ''? 'Select' : selectedCluster" class="overflow-dropdown-menu">
										<b-dropdown-item v-for="cluster in availableClusters" :key="cluster" @click="selectedCluster = cluster">
											{{cluster}} 
										</b-dropdown-item>
									</b-dropdown>
								</b-col>
							</b-row>
							
							<b-row>
								<!--<div class="stickytable" style="max-height:300px; width:100%" v-if="selectedCluster != ''">-->
								<b-col>
									<div v-if="selectedCluster != ''"> 
										<table v-if="this.cluster_data_dict[this.selectedCluster]['Structure_source'] != '[NA]'" class="clusterinfotable" id="cluster_info_table">
											<thead>
											</thead>
											<tbody>
												<tr><td>Type of signal</td><td>{{cluster_data_dict[selectedCluster]['Type']}}</td></tr>
												<tr><td>Affected gene(s)</td><td>{{cluster_data_dict[selectedCluster]['Affected_genes']}}</td></tr>
												<tr><td>Structure source</td><td>{{cluster_data_dict[selectedCluster]['Structure_source']}}</td></tr>
												<tr><td>Raw P value</td><td>{{cluster_data_dict[selectedCluster]['Raw_pvalue']}}</td></tr>

											</tbody>
										</table>
										<table v-if="this.cluster_data_dict[this.selectedCluster]['Structure_source'] == '[NA]'" class="clusterinfotable" id="cluster_info_table">
											<thead>
											</thead>
											<tbody>
												<tr><td>Type of signal</td><td>{{cluster_data_dict[selectedCluster]['Type']}}</td></tr>
												<tr><td>Affected gene</td><td>{{cluster_data_dict[selectedCluster]['Affected_genes']}}</td></tr>
												<tr><td>Number of LOF mutations</td><td>{{cluster_data_dict[selectedCluster]['Mutation_frequency']}}</td></tr>
												<tr><td>Enrichment</td><td>{{cluster_data_dict[selectedCluster]['LoF_enrichment']}}</td></tr>
												<tr><td>Raw P value</td><td>{{cluster_data_dict[selectedCluster]['Raw_pvalue']}}</td></tr>

											</tbody>
										</table>
									</div>
								</b-col>
								<!--</div>	-->
								
							</b-row>
							<b-row>
								<b-col>
									<!--<div class="signature-download-link"><a v-on:click="htmlToCSV('cluster_info_table', 'cluster.csv')" href="">Download potential driver mutations in this signal &#x21E9;</a></div>-->
									<div class="signature-download-link"><a v-on:click="exportMutationResTable()" href="">Download potential driver mutations in this signal &#x21E9;</a></div>
								</b-col>
							</b-row>
						</b-col>
						<b-col cols="6">
							<b-container>
								<b-row>	
									<b-col>
										<div v-if="availablePDBs.length > 0"> <b>Select a structure<br>(Structure:Chains):</b> </div>
									</b-col>
									<b-col>
										<div v-if="availablePDBs.length > 0"> 
											<!--<b-dropdown :text="selectedPDB === ''? 'Select' : selectedPDB" class="overflow-dropdown-menu">-->
											<b-dropdown :text="selectedPDB === ''? 'Select' : selectedPDB.split(':')[0] + ':' + selectedPDB.split(':')[1].replace('-', ',')" class="overflow-dropdown-menu">
													<!--<b-dropdown-item v-for="pdb in availablePDBs" :key="pdb" @click="selectedPDB = pdb">
														{{pdb}} ({{Object.keys(PDBInfoDict[pdb]).length}})
													</b-dropdown-item>-->
													<b-dropdown-item v-for="pdb in availablePDBs" :key="pdb" @click="selectedPDB = pdb">
														{{pdb.split(":")[0]}}:{{pdb.split(":")[1].replace("-", ",")}}
													</b-dropdown-item>
											</b-dropdown>
										</div>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<div v-if="availablePDBs.length == 0">
											<b> No PDB or AlphaFold2 structure<br>is available.</b>
										</div>
									</b-col>
								</b-row>
								
							</b-container>
							<!--<b-card header="PDB Structure">-->
							<div class="viewport">
								<div class="viewport-inside" id="viewport" v-show="availablePDBs.length != 0"></div>
								<div class="viewport-inside" v-show="availablePDBs.length == 0">
									<table class="viewport-empty">
										<thead>
											<tr><td>Structure visualization is not available.</td></tr>
										</thead>
									</table>
								</div>
								<!--<div class="viewport-empty" v-if="not showPDB">X</div>-->
							</div>
							<!--</b-card>-->
						</b-col>
					</b-row>
					<br>
					<b-row v-show="selectedCluster != '' && this.cluster_data_dict[selectedCluster]['Structure_source'] != '[NA]'">
						<b-col cols="4">
							<div class="circularplot-header">Residue-Residue Contact</div>
						</b-col>
						<b-col cols="8">
							<div class="circularplot-header">Mutation Frequency</div>
						</b-col>
					</b-row>
					<b-row v-show="selectedCluster != '' && this.cluster_data_dict[selectedCluster]['Structure_source'] != '[NA]'">
						<b-col cols="4">
							<div style="width: 100%; height: 300px; ">
								<svg class="circularplot-svg" style="height:300px" viewBox="0 0 300 300" id="circular_plot_svg"></svg>
							</div>
						</b-col>
						<b-col cols="8">
							<div class="scrollable-container" style="width: 100%; height: 300px; ">
								<svg class="proteinsnapshot-svg" id="protein_snapshot_svg" style="height:300px" viewBox="0 0 800 300"></svg>
							</div>
						</b-col>
					
					</b-row>
				</b-col>
			
			</b-row>
			<div class="place_holder">
			</div>
			<!-- Third section: Module Information -->
			<b-row>
				<div class="sec_header"> 
					Strongly Connected Subnetwork
				</div>
				<b-col>
					<b-row v-if="this.module_data_dict == null || Object.keys(this.module_data_dict).length == 0">
					<table class="not_found">
						<thead>
						<tr><td>This gene does not belong to any cellular subnetwork.</td></tr>
						</thead>
					</table>
					</b-row>
					<b-row>
						<!-- Legend -->
						<b-col cols="3">
							<div class="legend">Please mouse over a marker in the diagram below to see details.</div>
						</b-col>
						<b-col>
							<svg class="moduleplot-svg" viewBox="0 0 1000 50" id="legend_svg"></svg>
						</b-col>
					</b-row>
					<b-row>
						<!-- Diffusion plot -->
						<!--
						<b-col>
							<svg class="moduleplot-svg" viewBox="0 0 300 300" id="diffusion_plot_svg"></svg>
						</b-col>
						-->
						<!-- Functional plot -->
						<b-col>
							<div style="overflow-y:auto; overflow-x:auto ">
								<svg class="moduleplot-svg" viewBox="0 0 500 500" id="functional_plot_svg"></svg>
							</div>
							<!-- Extra table, only displayed during highlight-->
						</b-col>
					</b-row>
					<b-row>
						<!--<div style="min-height:200px; margin-left: auto; margin-right: auto;">-->
						<!--<div style="position: absolute; top:50px; left: 50px" v-if="module_target_table" id="module_target_table_div">-->
					</b-row>
				</b-col>
			</b-row>
			
		</b-container>
	<!--vbind:top="functional_table_top" vbind:left="functional_table_left" -->
	<!--<div vbind:style="functional_table_style">ABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABC</div>-->
	<!--<div style="position: absolute; display: block left:100px; top:100px">ABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABCABC</div>-->
		<!--<div id="module_target_table_div" display="block" style="position: absolute; display: block; left:200px; top:100px" v-if="module_target_table">-->
		<!-- Floats -->
		<div id="module_target_table_div" display="block" :style="functional_table_style" v-if="module_target_table">
			<table class="moduleinfotable" id="functional_table">
				<thead>
				<tr>
					<td>Signature ID</td>
					<td>Type of signature</td>
					<td>Structure source</td>
				</tr>
				</thead>
				<tbody>
					<tr v-for="(k, index) in module_target_table" :key="index">
						<td v-for="(v, index2) in k" :key="index2">
							{{v}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		
		<!-- using v-show here may be problematic for showing unknown green dots -->
		<!-- not a good coding practice to use uniprot_selection_tooltip_style for both tooltip template -->
		<!--<div class="uniprot_selection_tooltip_class" v-show="selectedUniprotResidues.length>-1" :style="uniprot_selection_tooltip_style">-->
		<div v-show="selectedUniprotResidues.length>-1" :style="uniprot_selection_tooltip_style">
			<div v-for="(v, k, index) in selectedUniprotResiduesMutationCounts" :key="index">
				<b>Residue</b> {{k}} <br>
				<b>Mutation frequency</b> {{v}}
			</div>
		</div>
		<div class="uniprot_selection_tooltip_class" v-show="selectedCircularPlotEdges.length>0" :style="uniprot_selection_tooltip_style">
			<div v-for="(v, k, index) in selectedCircularPlotEdgesDetails" :key="index" style="width:700px;">
				<b>Minimal 3D distance</b> {{v}} <br>
				<b>Source of 3D distance</b> {{k}} 
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import { Stage } from "ngl";
//import mylib from '@/view/mylib';
let mylib = require('@/view/mylib');

export default {
	name: "Home",
	components: {
	},
	props: {
		queryterm: {
			type: String,
		},
	},
	data() {
		return {
			// User query term
			userqueryterm: this.$route.params.queryterm,
		
			
			selected_module_gene: "",
			selectedPDB: "",
			cluster_data_dict:{},
			module_data_dict:{},
			uniprotInfoData:{},

			// From Axios
			query_uniprots: [],
			
			
			
			// selections
			selectedPDBChains:[],
			selectedUniprotProteins: [],
			selectedUniprotResidues: [],
			selectedCircularPlotEdges: [],
			selectedCluster: "",
			selectedMousePosition: [],
			uniprot_selection_tooltip_style: "",
			
			module_target_table: null,
			
			pdbRepresentations: null,
			
			// Store SVG elements
			circular_plot_elements: {},
			snapshot_uniprot_residues: {},
			snapshot_uniprot_backbones: {},
			
			// PDB Structure
			stage: null,
			stagePromise: null,
			showPDB: true,
			
			// default colors
			//unselected_uniprot_color : "#f58231",
			unselected_uniprot_color : "red",
			selected_uniprot_color : "#FFF200",
			
			circular_plot_selected_edge_color: "#FFF200",
			circular_plot_edge_color: "#d9d9d9",
			
			
			btnColors: [
				"success",
				"primary",
				"secondary",
				"danger",
				"warning",
				"info",
				"dark",
			],
			ballColors: ['#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075'], //["green", "blue", "gray", "#f87979", "yellow", "purple", "black"],
			myDefaultColors: ['#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075'],
			defaultClusterColors: ['#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075'],//['#e31a1c', '#1f78b4', '#33a02c', '#ff7f00', '#6a3d9a', '#b15928'],
			//defaultUniprotColors: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae"],
			defaultUniprotMainColor: "#67daff",
			defaultUniprotOtherColor: "#fec16f",
			functional_table_style: "position: absolute; display: block; left:100px; top:100px",
			functional_table_left: "1309px",
			functional_table_top: "900px",
			show: false,
			
			
			isLoading: false,
			download: false,
			imageUri: null,
			barChartData: [],
			pieChartData: [],
			pdbDataCollection: null,
			barChartDataCollection: null,
			pieChartDataCollection: null,
			violinChartDataCollection: null,
			datacollection: null,
			lineDatacollection: null,
			barOptions: null,
			pieOptions: null,
			protein_info_text: "",
			cluster_info_text: "",
			pdb_info_text: "",
			developing: false,
			debug: false,
		};
	},
	created() {
		const payload = {
			queryterm: this.userqueryterm
		};
		document.addEventListener('DOMContentLoaded', function(event) {
			const tooltipTriggers = document.querySelectorAll('circle');
			Array.from(tooltipTriggers).map(trigger => {
				trigger.addEventListener('mousemove', this.showTooltip);
				trigger.addEventListener('mouseout', this.hideTooltip);
			})
		});
		
		// hard-coded path. Must be renewed to the updated website name
		//const path = "http://localhost:5000/querysearch";
		const path = "http://netflow3dapi.yulab.org/querysearch";
		axios
			.post(path, payload)
			.then(res => {
				if (res.data.status == "success") {
					// The query
					this.query_uniprots = res.data.query_uniprots;
					
					this.uniprotInfoData = res.data.uniprot_info;
					
					this.cluster_data_dict = res.data.cluster_data_dict;
					
					this.module_data_dict = res.data.module_data_dict;
					//mylib.foo();
					// update selected cluster
					this.selectedCluster = Object.keys(this.cluster_data_dict)[0] // There must be at least one cluster. Set the first one as default
				} else {
					//alert("Failure: " + res.data.reason)
					alert("Unfortunately, we were unable to locate your gene or protein in our database. Please note that our search function is case sensitive, so it is important to ensure that you have entered the correct upper and lower case characters. If you have verified that your entry is accurate in this regard and your gene or protein is still not found, this indicates that NetFlow3D did not detect any significant 3D cluster or LOF enrichment signal associated with your gene or protein. This suggests that, based on somatic protein-altering mutations in our TCGA pan-cancer dataset, it is less probable for your gene to be associated with cancer.")
				}
			})
			.catch(error => {
				this.showError = true;
				console.log(error);
			});

		window.addEventListener("resize", this.handleResize);

		// test charts

	},
	mounted() {
		window.scrollTo(0, 0)	
		//var c = document.getElementById("protein_snapshot");
		//var ctx = c.getContext("2d");
		//this.proteinSnapshotCanvas = ctx;
		console.log("yingying 1")
		console.log(this.selectedCluster)
		console.log("yingying 1")
		document.onreadystatechange = () => {
			if (document.readyState == "complete" && this.selectedCluster != '') {
				this.updateProteinSnapshots();
			}
		}
	},
	destroyed() {
		window.removeEventListener("resize", this.handleResize);
	},
	computed: {
		availableClusters: function() {
			if (this.cluster_data_dict !== null) {
				return Object.keys(this.cluster_data_dict);
			}
			else
				return [];
		},
		availableUniprotResidues: function() {
			if (this.cluster_data_dict !== null && this.selectedCluster !== "") {
				return Object.keys(this.cluster_data_dict[this.selectedCluster]["Mutation_frequency"])
				}
			else
				return [];
		},
		availableUniprots: function() {
			return Array.from(new Set(this.availableUniprotResidues.map(uniprot_residue => uniprot_residue.split("_")[0])))
		},
		availablePDBs: function() {
			// Describe the available PDBs given the current selected cluster
			if (this.cluster_data_dict !== null && this.selectedCluster !== "" && Object.keys(this.cluster_data_dict[this.selectedCluster]).includes("Structure_Visualization")) {
				let b = Object.values(this.cluster_data_dict[this.selectedCluster]["Structure_Visualization"]);
				return Array.from(b);
			}
			else
				return [];
		},
		pdbResiduesOnCurrentStructure: function() {
			if (!(this.availablePDBs.includes(this.selectedPDB))) {
				return new Set();
			}
			else {
				//return new Set(Object.values(this.cluster_data_dict[this.selectedCluster]["uniprot_to_pdb"]).flat().filter(pdb_residue => pdb_residue.split("_")[0] === this.selectedPDB));
				if (this.selectedPDB.substring(0,2) === "AF"){
					return new Set(Object.values(this.cluster_data_dict[this.selectedCluster]["uniprot_to_pdb"]).flat().filter(pdb_residue => (pdb_residue.split("_")[0] + ":" + pdb_residue.split("_")[1]) === this.selectedPDB.split("_")[0] + ":" + this.selectedPDB.split(":")[1]));
				} else {
					let pdb_nochain = this.selectedPDB.split(":")[0];
					let pdb_chains = this.selectedPDB.split(":")[1].split("-").map(function (i) {return pdb_nochain + ":" + i});
					return new Set(Object.values(this.cluster_data_dict[this.selectedCluster]["uniprot_to_pdb"]).flat().filter(pdb_residue => pdb_chains.includes(pdb_residue.split("_")[0] + ":" + pdb_residue.split("_")[1])));
				}
				//return new Set(Object.values(this.clusterData).map((c) => c.uniprot_residues).flat().map((uniprot_residue) => this.uniprot_pdb_residue_map[uniprot_residue]).flat().filter(pdb_residue => pdb_residue.split("_")[0] === this.selectedPDB));
			}
		},
		selectedUniprotResiduesMutationCounts: function() {
			let mcs = {}
			for (let uniprot_residue of this.selectedUniprotResidues) {
				//console.log(uniprot_residue);
				//console.log(this.cluster_data_dict[this.selectedCluster]["Mutation_frequency"]);
				mcs[uniprot_residue] = this.cluster_data_dict[this.selectedCluster]["Mutation_frequency"][uniprot_residue]
			}
			console.log(mcs);
			return mcs;
		},
		selectedCircularPlotEdgesDetails: function() {
			let mcs = {}
			for (let [n1, n2, d, info] of this.selectedCircularPlotEdges) {
				mcs[`${info}`] = `${d.toFixed(1)}\u212B`
			}
			return mcs;
		},
		uniprotToPDBChain: function() {
			// Depends on uniprot_pdb_residue_map
			
			let ud = {};
			if (this.cluster_data_dict !== null && this.selectedCluster !== "" && this.cluster_data_dict[this.selectedCluster]["Structure_source"] != '[NA]') {
				Object.entries(this.cluster_data_dict[this.selectedCluster]["uniprot_to_pdb"]).forEach(([uniprot_residue, pdb_residues]) => {
					let uniprot_name = uniprot_residue.split("_")[0];
					pdb_residues.forEach(pdb_residue => {
						let pdb_name = pdb_residue.split("_")[0];
						let pdb_chain = pdb_residue.split("_")[1];
						if (!(uniprot_name in ud)) {
							ud[uniprot_name] = {};
						}
						if (!(pdb_name in ud[uniprot_name])) {
							ud[uniprot_name][pdb_name] = new Set();
						}
						ud[uniprot_name][pdb_name].add(pdb_chain);
					});
				});
			}
			return ud;
		},
		clusterColorMap: function() {
			// Depends on clusterData, defaultClusterColors
			let colorCycle = [...this.defaultClusterColors];
			// loop through all stack labels and construct the data array
			let ccMap = {}
			for (let cluster_id in this.cluster_data_dict) {
				ccMap[cluster_id] = colorCycle[0];
				colorCycle.push(colorCycle.shift());
			}
			return ccMap;
		},
		uniprotResidueColorMap: function() {
			// Depends on clusterData, clusterColorMap
			
			let uniprotCMap = {};
			if (this.cluster_data_dict[this.selectedCluster]["Structure_source"] != '[NA]') {
				Object.keys(this.cluster_data_dict[this.selectedCluster]["uniprot_to_pdb"]).forEach((uniprot_residue) => uniprotCMap[uniprot_residue] = "red");
				/*Object.entries(this.cluster_data_dict).forEach(([cluster_id, c]) => {
					let color = this.clusterColorMap[cluster_id];
					c.uniprot_residues.forEach((uniprot_residue) => {
						uniprotCMap[uniprot_residue] = color;
					})
				});
				*/
			}
			return uniprotCMap;
		},
		pdbResidueColorMap: function() {
			// Depends on uniprotResidueColorMap, uniprot_pdb_residue_map
			let pdbCMap = {};
			Object.entries(this.uniprotResidueColorMap).forEach(([uniprot_residue, color]) => {
				this.cluster_data_dict[this.selectedCluster]["uniprot_to_pdb"][uniprot_residue].forEach((pdb_residue) => {
					pdbCMap[pdb_residue] = color;
				})
			});
			return pdbCMap;
		},
		uniprotColorMap: function() {
			// Depends on uniprotInfoData, defaultUniprotColors
			//let idx = 0;
			let cMap = {};
			for (let uniprot_name in this.uniprotInfoData) {
				cMap[uniprot_name] = (this.query_uniprots.includes(uniprot_name))? this.defaultUniprotMainColor : this.defaultUniprotOtherColor;
				//cMap[uniprot_name] = this.defaultUniprotColors[idx % this.defaultUniprotColors.length];
				//idx += 1
			}
			return cMap;
		},
		pdbChainColorMap: function() {
			// Depends on uniprotToPDBChain, uniprotColorMap, selectedPDB
			let cMap = {};
			for (let uniprot_name in this.uniprotColorMap) {
				let c = this.uniprotColorMap[uniprot_name];
				for (let pdb in this.uniprotToPDBChain[uniprot_name]) {
					let pdbChains = [...this.uniprotToPDBChain[uniprot_name][pdb]];
					pdbChains.sort();
					pdbChains.forEach(pdbChain => {
						if (!(pdb in cMap)) {
							cMap[pdb] = {};
						}
						cMap[pdb][pdbChain] = c;
					});
				}
			}
			return cMap;
		},
		PDBInfoDict: function() {
			let ud = {}
			if (this.selectedCluster !== "" && this.cluster_data_dict[this.selectedCluster]["Structure_source"] != '[NA]') {
				Object.entries(this.cluster_data_dict[this.selectedCluster]["uniprot_to_pdb"]).forEach(([uniprot_residue, pdb_residues]) => {
					let uniprot_name, uniprot_pos;
					[uniprot_name, uniprot_pos] = uniprot_residue.split("_");
					pdb_residues.forEach(pdb_residue => {
						let pdb_name = pdb_residue.split("_")[0];
						if (!(pdb_name in ud)) {
							ud[pdb_name] = {}
						}
						if (!(uniprot_name in ud[pdb_name])) {
							ud[pdb_name][uniprot_name] = new Set()
						}
						ud[pdb_name][uniprot_name].add(parseInt(uniprot_pos))
					});
				});
			}
			return ud;
		},
		PDBInfoDictChainSeperated: function() {
			let ud = {}
			Object.entries(this.cluster_data_dict[this.selectedCluster]["uniprot_to_pdb"]).forEach(([uniprot_residue, pdb_residues]) => {
				let uniprot_name, uniprot_pos;
				[uniprot_name, uniprot_pos] = uniprot_residue.split("_");
				pdb_residues.forEach(pdb_residue => {
					let pdb_name = pdb_residue.split("_")[0];
					let pdb_chain = pdb_residue.split("_")[1];
					if (!(pdb_name in ud)) {
						ud[pdb_name] = {};
					}
					if (!(pdb_chain in ud[pdb_name])) {
						ud[pdb_name][pdb_chain] = {uniprot_name: uniprot_name, positions:new Set()};
					}
					ud[pdb_name][pdb_chain]["positions"].add(parseInt(uniprot_pos))
				});
			});
			return ud;
		},
		// Cluster display residues by gene
		cluster_info_display_uniprot_residues: function() {
			let d = {}
			for (const uniprot_residue of Object.keys(this.cluster_data_dict[this.selectedCluster]['Mutation_frequency'])) {
				let uniprot_name, uniprot_pos;
				[uniprot_name, uniprot_pos] = uniprot_residue.split("_");
				if (!(uniprot_name in d)) {
					d[uniprot_name] = [];
				}
				d[uniprot_name].push(uniprot_pos);
			}
			return d;
		},
		/*module_target_table: function() {
			console.log("Updated!");
			if (this.selected_functional_signatures)
				if (this.selected_functional_attribute[0] == "node")
					return this.module_data_dict["functional"]["node"][this.selected_functional_attribute[1]]["Signatures"];
				else {
					return this.module_data_dict["functional"]["node"][this.selected_functional_attribute[1]]["Signatures"];
				}
			return [];
		},
		*/
	},
	watch: {
		// Change in selected PDB
		availablePDBs: function() {
			if (Object.keys(this.PDBInfoDict).length > 0) {
				this.selectedPDB = this.availablePDBs[0];
				//this.selectedPDB = Object.keys(this.PDBInfoDict)[0];
			}
		},
		
		selectedPDB: function() {
			let vm = this;
			setTimeout(function(){
				vm.updatePDBVisualization();
				// If not setting the delay, then cannot display default structure correctly. 
				// Potential problem is that the loading of availablePDBs is earlier than other important functions on protein snapshots or circular plots. No time to check
			}, 1000); 
			//this.updateProteinSnapshots();
		},
		
		selectedUniprotProteins: function(newUniprots) {
			// Triggered when mouseover on the uniprot protein

			// Update the selected PDB chains
			if (newUniprots.length === 0)
				this.selectedPDBChains = [];
			else {
				newUniprots.forEach(uniprot_name => {
					let c = [];
					if (this.selectedPDB.split("_")[0].split(":")[0] in this.uniprotToPDBChain[uniprot_name])

						c = [...this.uniprotToPDBChain[uniprot_name][this.selectedPDB.split("_")[0].split(":")[0]]];
					c.sort();
					this.selectedPDBChains = c;
				});
			}
			// Update 1D Plot
			
			// Update circular plot
		},
		// Change in selected residue
		selectedUniprotResidues: function(newResidues, oldResidues) {
			// Update Structure
			if (this.availablePDBs.length > 0) {
				// Assign "non-selected" color to the old sets of selected residues
				oldResidues.forEach(uniprot_residue =>
							this.cluster_data_dict[this.selectedCluster]["uniprot_to_pdb"][uniprot_residue].filter(pdb_residue => this.pdbResiduesOnCurrentStructure.has(pdb_residue)).forEach(pdb_residue => {
								this.updatePDBResidueColor(pdb_residue, false);
							}));
				// Assign "selected" color to the new sets of selected residues
				newResidues.forEach(uniprot_residue =>
							this.cluster_data_dict[this.selectedCluster]["uniprot_to_pdb"][uniprot_residue].filter(pdb_residue => this.pdbResiduesOnCurrentStructure.has(pdb_residue)).forEach(pdb_residue => {
								this.updatePDBResidueColor(pdb_residue, true);
							}));
			}
			// Update 1D Plot
			oldResidues.forEach(uniprot_residue =>
				this.snapshot_uniprot_residues[uniprot_residue].setAttribute("fill", this.unselected_uniprot_color)
			);
			newResidues.forEach(uniprot_residue =>
				this.snapshot_uniprot_residues[uniprot_residue].setAttribute("fill", this.selected_uniprot_color)
			);
			// Update circular plot
			oldResidues.forEach(uniprot_residue =>
				this.circular_plot_elements[uniprot_residue].setAttribute("fill", this.unselected_uniprot_color)
			);
			newResidues.forEach(uniprot_residue =>
				this.circular_plot_elements[uniprot_residue].setAttribute("fill", this.selected_uniprot_color)
			);
			
			let ex = 0
			let [pageX, pageY] = this.selectedMousePosition;
			if (pageX > window.innerWidth / 2)
				ex = pageX - 100;
			else
				ex = pageX + 10
			this.uniprot_selection_tooltip_style = "background-color: #d7e9b5;border-radius: 10px;padding: 15px;text-align: left;overflow:hidden; position: absolute; display: block; left:" +(ex) + "px; top: " + (pageY + 10) + "px";
			
		},
		selectedCircularPlotEdges: function(newEdges, oldEdges) {
			let ex = 0
			let [pageX, pageY] = this.selectedMousePosition;
			if (pageX > window.innerWidth / 2)
				ex = pageX - 100;
			else
				ex = pageX + 10
			this.uniprot_selection_tooltip_style = "overflow:hidden; position: absolute; display: block; left:" +(ex) + "px; top: " + (pageY + 10) + "px";
		},
		selectedPDBChains: function(newChains, oldChains) {
			oldChains.forEach(pdbChain => {
				this.updatePDBChainColor(pdbChain, false);
			});
			newChains.forEach(pdbChain => {
				this.updatePDBChainColor(pdbChain, true);
			});
		},
		// Change in selected cluster
		selectedCluster: function(cluster) {
		/*
			if (this.availablePDBs.length > 0) {
				this.selectedPDB = this.availablePDBs[0];
			}
			*/
			if (this.cluster_data_dict[this.selectedCluster]["Structure_source"] != '[NA]') {
				let vm = this;
				setTimeout(function(){
					vm.updatePDBVisualization();
				}, 1000);
				console.log("yingying")
				console.log(this.svg)
				console.log("yingying")
				this.updateCircularPlot();
				this.updateProteinSnapshots();
			}
		},
		module_data_dict: function() {
			this.updateFunctionalPlot();
			this.updateDiffusionPlot();
			this.updateLegendPlot();
		}
	},
	methods: {
		showTooltip: function(event) {
		let element = event.target;
		let tooltipElement = document.getElementById('tooltip');
		let title;
		if (!element.dataset.title) {
		let titleElement = element.querySelector('title');
		title = titleElement.innerHTML;
		event.target.setAttribute('data-title', title);
		titleElement.parentNode.removeChild(titleElement);
		} else {
		title = element.dataset.title;
		}
		tooltipElement.innerHTML = title;
		tooltipElement.style.display = 'block';
		tooltipElement.style.left = event.pageX + 10 + 'px';
		tooltipElement.style.top = event.pageY + 10 + 'px';
		},

		hideTooltip: function() {
		var tooltip = document.getElementById('tooltip');
		tooltip.style.display = 'none';
		},
	
		exportTableToTSV: function(tableID, filename = '') {
			return mylib.exportTableToTSV(tableID, filename)
		},
		htmlToCSV: function(tableID, filename='result.csv') {
			return mylib.htmlToCSV(tableID, filename)
		},
		updatePDBVisualization: function() {
			/** A function that is called upon changing the selected PDBs
			  * This function requires 
			  * (1) selectedPDB
			  * (2) stage
			  * (3) pdbResiduesOnCurrentStructure
			  * (4) pdbChainColorMap
			  * It will modify the following parameters
			  * (1) pdbRepresentations
				
			  */
			
			// Update stagePromise
			let pdb = this.selectedPDB;
			if (this.selectedPDB !== null && this.selectedPDB != "") {
				console.log("A1")
				console.log(this.cluster_data_dict[this.selectedCluster]['Structure_source'])
				//let test_yy = "aksdlmdssld;sd".split("s")
				//let new_test = test_yy.map(function (i) {return "haha    " + i});
				//console.log(new_test)
				if (!this.stage) {
					console.log("A2")
					// Create a new stage
					this.stage = new Stage("viewport", { backgroundColor: "white" }); // { backgroundColor: "#d7e9b5" }
					// Fullscreen listener
					this.stage.viewer.container.addEventListener(
						"dblclick",
						this.toggleScreen
					);
				} else {
					console.log("A3")
					// Remove all components from the stage
					this.stage.removeAllComponents();
				}
				console.log("A4")
				// Load the PDB structure
				// Modify this to load from file
				//this.stagePromise = this.stage.loadFile("http://localhost:8080/" + pdb.split(":")[0], {
				//this.stagePromise = this.stage.loadFile("http://netflow3d.yulab.org/" + pdb.split(":")[0], {
				if (pdb.substring(0,2) === "AF"){
					this.stagePromise = this.stage.loadFile("http://netflow3d.yulab.org/AF2_structures/" + pdb.split("_")[0] + "_v4.pdb", {
						defaultRepresentation: false,
						firstModelOnly: true
					})
				} else {
					this.stagePromise = this.stage.loadFile("https://files.rcsb.org/download/" + pdb.split(":")[0] + ".pdb", {
						defaultRepresentation: false,
						firstModelOnly: true
					})
				}
				console.log(process.cwd())

				// Reset pdbRepresentations
				// This step includes updating the chain color and residue color
				console.log("A5")
				this.pdbRepresentations = {"chain":{}, "residue":{}};
				let vm = this;
				this.stagePromise.then(function(comp) {
					// initialize pdbRepresentations
					vm.selectedPDB.split(":")[1].split("-").forEach(pdbChain => {
						vm.updatePDBChainColor(pdbChain, false);
					});
					Object.keys(vm.pdbResidueColorMap).filter(pdbResidue => vm.pdbResiduesOnCurrentStructure.has(pdbResidue)).forEach(pdbResidue => {
						vm.updatePDBResidueColor(pdbResidue, false);
					});
					comp.autoView();
				});
				console.log("A6")
			}
		},
		updatePDBChainColor(pdbChain, useSelectedColor) {
			// Depends on stagePromise, pdbRepresentations, pdbChainColorMap
			let vm = this;
			if (vm.selectedPDB.substring(0,2) === "AF"){
				vm.stagePromise.then(function(comp) {
					if (!(pdbChain in vm.pdbRepresentations["chain"])) {
						vm.pdbRepresentations["chain"][pdbChain] = comp.addRepresentation("cartoon", {color: useSelectedColor ? "#ffeda0" : vm.pdbChainColorMap[vm.selectedPDB.split("_")[0]][pdbChain], sele: ":" + pdbChain});
					}
					vm.pdbRepresentations["chain"][pdbChain].setColor(useSelectedColor ? "#ffeda0" : vm.pdbChainColorMap[vm.selectedPDB.split("_")[0]][pdbChain]);
				});
			} else {
				vm.stagePromise.then(function(comp) {
					if (!(pdbChain in vm.pdbRepresentations["chain"])) {
						vm.pdbRepresentations["chain"][pdbChain] = comp.addRepresentation("cartoon", {color: useSelectedColor ? "#ffeda0" : vm.pdbChainColorMap[vm.selectedPDB.split(":")[0]][pdbChain], sele: ":" + pdbChain});
					}
					vm.pdbRepresentations["chain"][pdbChain].setColor(useSelectedColor ? "#ffeda0" : vm.pdbChainColorMap[vm.selectedPDB.split(":")[0]][pdbChain]);
				});
			}
		},
		updatePDBResidueColor(pdbResidue, useSelectedColor) {
			// Depends on stagePromise, pdbRepresentations, pdbResidueColorMap
			let vm = this;
			vm.stagePromise.then(function(comp) {
				let pdbName, pdbChain, pdbPos;
				[pdbName, pdbChain, pdbPos] = pdbResidue.split("_");
				if (vm.debug)
					console.log(pdbName);
				if (!(pdbResidue in vm.pdbRepresentations["residue"])) {
					vm.pdbRepresentations["residue"][pdbResidue] = comp.addRepresentation("spacefill", {
						sele: ":" + pdbChain + " and " + pdbPos + " and .CA",
						color: useSelectedColor ? vm.selected_uniprot_color : vm.pdbResidueColorMap[pdbResidue]
					})
				}
				vm.pdbRepresentations["residue"][pdbResidue].setColor(useSelectedColor ? vm.selected_uniprot_color : vm.pdbResidueColorMap[pdbResidue]);
			});
		},
		compactResiduePositions(positions) {
			// combine an array 1, 2, 3, 5, 6, 10 to 1-3, 5-6, 10
			let sorted_positions = positions;
			sorted_positions.sort(function(a, b) {return a - b;});
			let ss = [];
			let first_p = null;
			let last_p = null;
			sorted_positions.forEach(p => {
				if (last_p === null) {
					first_p = p;
					last_p = p;
				}
				else if (p - last_p == 1) {
					last_p = p;
				}
				else {
					ss.push(first_p === last_p ? `${first_p}` : `${first_p}-${last_p}`);
					first_p = p;
					last_p = p;
				}
			});
			if (last_p !== null) {
				ss.push(first_p === last_p ? `${first_p}` : `${first_p}-${last_p}`);
			}
			return ss
		},
		updateCircularPlot() {
			if (this.selectedCluster != '' && !this.cluster_data_dict)
				return;
			if (this.selectedCluster == '' | this.cluster_data_dict[this.selectedCluster]['Structure_source'] == '[NA]')
				return;
			this.circular_plot_elements = {};
			let svg = document.getElementById("circular_plot_svg");
			console.log("yingying")
			console.log(this.selectedCluster)
			console.log(svg)
			console.log("yingying")
			let svgClear = function(svg) {
				while (svg.lastChild) {
					svg.removeChild(svg.lastChild);
				}
			}

			let svgDrawCircle = function(svg, x, y, r, c) {
				var svgns = "http://www.w3.org/2000/svg";
				var circ = document.createElementNS(svgns, 'circle');
				circ.setAttributeNS(null, 'cx', x);
				circ.setAttributeNS(null, 'cy', y);
				circ.setAttributeNS(null, 'r', r);
				circ.setAttributeNS(null, 'fill', c);
				svg.appendChild(circ);
				return circ;
			}
			let svgDrawLine = function(svg, x1, y1, x2, y2, c, sw) {
				var svgns = "http://www.w3.org/2000/svg";
				var line = document.createElementNS(svgns, 'line');
				line.setAttributeNS(null, 'x1', x1);
				line.setAttributeNS(null, 'x2', x2);
				line.setAttributeNS(null, 'y1', y1);
				line.setAttributeNS(null, 'y2', y2);
				line.setAttributeNS(null, 'stroke', c);
				line.setAttributeNS(null, 'stroke-width', sw);
				
				svg.appendChild(line);
				return line;
			}
			let svgDrawText = function(svg, x, y, c, t, fs) {
				var svgns = "http://www.w3.org/2000/svg";
				var text = document.createElementNS(svgns, 'text');
				text.setAttributeNS(null, 'x', x);
				text.setAttributeNS(null, 'y', y);
				text.setAttributeNS(null, 'fill', c);
				text.setAttributeNS(null, 'font-size', fs);
				text.setAttributeNS(null, 'alignment-baseline', 'middle');
				text.setAttributeNS(null, 'text-anchor', 'middle');
				
				text.textContent = t;
				svg.appendChild(text);
				return text;
			}
			let svgDrawArc = function(svg, x1, y1, x2, y2, large_arc_flag, radius, c, sw) {
				var svgns = "http://www.w3.org/2000/svg";
				var path = document.createElementNS(svgns, 'path');
				console.log(x1, y1, x2, y2, large_arc_flag, radius, c, sw);
				path.setAttributeNS(null, 'd', `M ${x1} ${y1} A ${radius} ${radius} 0 ${large_arc_flag} 1 ${x2} ${y2}`);
				path.setAttributeNS(null, 'stroke', c);
				path.setAttributeNS(null, 'stroke-width', sw);
				path.setAttributeNS(null, 'fill', "transparent");
				svg.appendChild(path);

				return path;
			}
			console.log("after 3")
			let vm = this;
			let svgWidth = 300;
			let arcWidth = 10;
			let nodeFactor = 0.8;
			let nodeTextFactor = 1;
			let arcFactor = 1.2;
			let arcTextFactor = 1.5;
			let nodeFontSize = '10px';
			let arcFontSize = '15px';
			let edge_width=3;

			let coor_mod = function(p, svgWidth) {
				return (p + 1) / 2 * .5 * svgWidth + svgWidth *.25
			}
			svgClear(svg);
			console.log("after 5")
			//if (this.cluster_data_dict[this.selectedCluster]["Structure_source"] == "PDB") {
				let circs = [];
				let edges = [];
				console.log("after 6")
				
				let cdn = this.cluster_data_dict[this.selectedCluster]["Circular"]["node"];
				let cde = this.cluster_data_dict[this.selectedCluster]["Circular"]["edge"];
				let cda = this.cluster_data_dict[this.selectedCluster]["Circular"]["arc"];
				
				// Arc
				for (let key in cda) {
					const [[x1, y1], [x2, y2], large_arc_flag] = cda[key];
					let factor = 1.2;
					let factor2 = 1.4
					svgDrawArc(svg, coor_mod(x1 * arcFactor, svgWidth), coor_mod(y1 * arcFactor, svgWidth), coor_mod(x2 * arcFactor, svgWidth), coor_mod(y2 * arcFactor, svgWidth), large_arc_flag, svgWidth / 4 * 1.3, 
						this.uniprotColorMap[key], arcWidth);
					svgDrawCircle(svg, coor_mod(x1 * arcFactor, svgWidth), coor_mod(y1 * arcFactor, svgWidth), arcWidth * 0.85, this.uniprotColorMap[key])
					let text = svgDrawText(svg, coor_mod(x1 * arcTextFactor, svgWidth), coor_mod(y1 * arcTextFactor, svgWidth), "black", key, arcFontSize);
				}
				// Edge
				for (let [n1, n2, d, info] of cde) {
					//let line = svgDrawLine(svg, coor_mod(cdn[n1][0] * nodeFactor, svgWidth), coor_mod(cdn[n1][1] * nodeFactor, svgWidth), coor_mod(cdn[n2][0] * nodeFactor, svgWidth), coor_mod(cdn[n2][1] * nodeFactor, svgWidth), this.circular_plot_edge_color, edge_width, `${n1},${n2} (${d.toFixed(1)}\u212B)`);
					let line = svgDrawLine(svg, coor_mod(cdn[n1][0] * nodeFactor, svgWidth), coor_mod(cdn[n1][1] * nodeFactor, svgWidth), coor_mod(cdn[n2][0] * nodeFactor, svgWidth), coor_mod(cdn[n2][1] * nodeFactor, svgWidth), this.circular_plot_edge_color, edge_width, );
					line.addEventListener("mousemove", function(e) {
						line.setAttributeNS(null, 'stroke', vm.circular_plot_selected_edge_color);
						vm.selectedMousePosition = [e.pageX, e.pageY]	
						vm.selectedCircularPlotEdges = [[n1, n2, d, info]];
						
					});
					line.addEventListener("mouseout", function(e) {
						line.setAttributeNS(null, 'stroke', vm.circular_plot_edge_color);
						vm.selectedMousePosition = []	
						vm.selectedCircularPlotEdges = [];
						
					});
				}
				if (cde.length == 0) {
					svgDrawText(svg, coor_mod(0, svgWidth), coor_mod(0, svgWidth) - 20, "#969696", "Residue-Residue", 12);
					svgDrawText(svg, coor_mod(0, svgWidth), coor_mod(0, svgWidth), "#969696", "contact information", 12);
					svgDrawText(svg, coor_mod(0, svgWidth), coor_mod(0, svgWidth) + 20, "#969696", "not available", 12);
				}
				
				// Node
				for (let key in cdn) {
					let circx = cdn[key][0];
					let circy = cdn[key][1];
					
					let circ = svgDrawCircle(svg, coor_mod(circx * nodeFactor, svgWidth), coor_mod(circy * nodeFactor, svgWidth), svgWidth / 50, this.unselected_uniprot_color);
					svgDrawText(svg, coor_mod(circx * nodeTextFactor, svgWidth), coor_mod(circy * nodeTextFactor, svgWidth), "black", key.split("_")[1], nodeFontSize);
					this.circular_plot_elements[key] = circ;
					circ.addEventListener("mousemove", function(e) {
						vm.selectedMousePosition = [e.pageX, e.pageY]	
						vm.selectedUniprotResidues = [key];
					});
					circ.addEventListener("mouseout", function(e) {
						vm.selectedMousePosition = []	
						vm.selectedUniprotResidues = [];
					});
					
				}
				console.log("after 4")
				

			//}
			
		},
		updateProteinSnapshots() {
			// Draw protein snapshots with rect bar as protein backbone and ball+stick as mutations
			if (!this.uniprotInfoData)
				return;
			if (this.cluster_data_dict[this.selectedCluster]["Structure_source"] == '[NA]')
				return;
			var svg = document.getElementById("protein_snapshot_svg");

			let svgDrawRect = function(svg, x, y, w, h, c) {
				var svgns = "http://www.w3.org/2000/svg";
				var rect = document.createElementNS(svgns, 'rect');
				rect.setAttributeNS(null, 'x', x);
				rect.setAttributeNS(null, 'y', y);
				rect.setAttributeNS(null, 'width', w);
				rect.setAttributeNS(null, 'height', h);
				rect.setAttributeNS(null, 'fill', c);
				svg.appendChild(rect);
			}
			let svgDrawText = function(svg, x, y, c, t) {
				var svgns = "http://www.w3.org/2000/svg";
				var text = document.createElementNS(svgns, 'text');
				text.setAttributeNS(null, 'x', x);
				text.setAttributeNS(null, 'y', y);
				text.setAttributeNS(null, 'fill', c);
				text.setAttributeNS(null, 'font-size', "12px");
				text.setAttributeNS(null, 'alignment-baseline', 'hanging');
				text.textContent = t;
				svg.appendChild(text);
			}
			let svgDrawCircle = function(svg, x, y, r, c) {
				var svgns = "http://www.w3.org/2000/svg";
				var circ = document.createElementNS(svgns, 'circle');
				circ.setAttributeNS(null, 'cx', x);
				circ.setAttributeNS(null, 'cy', y);
				circ.setAttributeNS(null, 'r', r);
				circ.setAttributeNS(null, 'fill', c);
				svg.appendChild(circ);
				return circ;
			}
			let svgDrawLine = function(svg, x1, y1, x2, y2, c, sw, tooltip) {
				var svgns = "http://www.w3.org/2000/svg";
				var line = document.createElementNS(svgns, 'line');
				line.setAttributeNS(null, 'x1', x1);
				line.setAttributeNS(null, 'x2', x2);
				line.setAttributeNS(null, 'y1', y1);
				line.setAttributeNS(null, 'y2', y2);
				line.setAttributeNS(null, 'stroke', c);
				line.setAttributeNS(null, 'stroke-width', sw);
				
				var title = document.createElementNS(svgns, 'title');
				title.textContent = tooltip;//JSON Object
				line.appendChild(title);
				svg.appendChild(line);
				return line;
			}
			let svgDraw = function(svg, element, attributes){
				var svgns = "http://www.w3.org/2000/svg";
				var e = document.createElementNS(svgns, element);
				for (const [key, value] of Object.entries(attributes)) {
					e.setAttributeNS(null, key, value);
				}
				svg.appendChild(e);
				return e;
			}
			
			let svgClear = function(svg) {
				while (svg.lastChild) {
					svg.removeChild(svg.lastChild);
				}
			}
			let svgInPath = function(mx, my, x, y, w, h) {
				return mx >= x && mx <= x + w && my >= y && my <= y + h
			}

			
			
			let vm = this;
			let total_proteins = vm.availableUniprots.length;
			
			let protein_snapshot_residue_radius = 3;
			
			let backbone_height = 10;
			let backbone_ball_height = 100;
			let backbone_space = 5;
			let svg_flanking_space = 5
			let text_width = 100;
			let draw_width = 800 - text_width; //
			let residue_extra_search_width = 5;
			let max_mut_freq_lim = 5;
			let extra_space = Math.max(0, (300 - (backbone_height + backbone_space + backbone_ball_height) * total_proteins));
			let initial_height = extra_space / total_proteins / 2;
			//let initial_height = Math.max(0, (300 - (backbone_height + backbone_space + backbone_ball_height) * total_proteins) / 2);
			// let initial_height = 0;
			//let extra_space = svgHeight - (backbone_height + backbone_space + backbone_ball_height) * this.availableUniprots
			
			
			svgClear(svg);
			//svg.setAttribute("height", (backbone_height + backbone_space + backbone_ball_height) * this.availableUniprots.length + svg_flanking_space);
			//svg.setAttribute("height", 500)
			//let max_uniprot_len = Math.max(...Object.values(this.uniprotInfoData).map(u => u.length));

			let uniprot_y = {};
			let i = initial_height + backbone_space + backbone_ball_height;
			this.availableUniprots.forEach(uniprot_name => {
				uniprot_y[uniprot_name] = i;
				i += backbone_height + backbone_space + backbone_ball_height + extra_space / total_proteins;
			});

			let uniprot_backbone_rects = {};
			
			// Store the residue and backbones so that we can update them
			let snapshot_uniprot_residues = {};
			let snapshot_uniprot_backbones = {};

			let max_protein_length = Math.max(...this.availableUniprots.map((uniprot_name) => vm.uniprotInfoData[uniprot_name]["length"]));
				
			// the uniprot bar setting
			this.availableUniprots.forEach((uniprot_name) => {
				let u = this.uniprotInfoData[uniprot_name];
				uniprot_backbone_rects[uniprot_name] = [];
				if (this.selectedPDB !== "" && Object.keys(this.PDBInfoDict).length !== 0 && this.selectedPDB.split("_")[0].split(":")[0] in this.PDBInfoDict && uniprot_name in this.PDBInfoDict[this.selectedPDB.split("_")[0].split(":")[0]]) {
					/*
					for (let p = 1; p <= u.length; p++) {
						uniprot_backbone_rects[uniprot_name].push({x: text_width + (p - 1) * 1.0 / u["length"] * draw_width,
							y: uniprot_y[uniprot_name],
							w: 1 * 1.0 / u["length"] * draw_width,
							h: backbone_height,
							//c: this.PDBInfoDict[this.selectedPDB.split("_")[0].split(":")[0]][uniprot_name].has(p) ? this.uniprotColorMap[uniprot_name] : "#cccccc"});
							c: this.uniprotColorMap[uniprot_name]});
					}*/
					//uniprot_backbone_rects[uniprot_name].push({x: text_width, y: uniprot_y[uniprot_name], w: u.length * 1.0 / max_protein_length * draw_width, h: backbone_height, c: this.uniprotColorMap[uniprot_name]});
					uniprot_backbone_rects[uniprot_name].push({x: text_width, y: uniprot_y[uniprot_name], w: u.length * 1.0 / max_protein_length * draw_width, h: backbone_height, c: this.uniprotColorMap[uniprot_name]});
				}
				else {
					uniprot_backbone_rects[uniprot_name].push({x: text_width, y: uniprot_y[uniprot_name], w: u.length * 1.0 / max_protein_length * draw_width, h: backbone_height, c: this.uniprotColorMap[uniprot_name]});
				}
			});
			
			
			let max_mutation_frequency = Math.max(...vm.availableUniprotResidues.map(uniprot_residue => this.cluster_data_dict[this.selectedCluster]["Mutation_frequency"][uniprot_residue]));
			if (max_mutation_frequency > max_mut_freq_lim)
				max_mutation_frequency = max_mut_freq_lim;

			// hotfix
			max_mutation_frequency = max_mut_freq_lim
			
			
			vm.snapshot_uniprot_residues = snapshot_uniprot_residues;
			
			//
			Object.entries(uniprot_y).forEach(([uniprot_name, uy]) => {
				let text_uniprotname = svgDraw(svg, "text", {"x":10, 
												"y":uy - 25, 
												"fill":"#000000",
												'alignment-baseline': 'hanging',
												'font-size': "15px",
												"text-anchor":"start",
												});
				text_uniprotname.textContent = uniprot_name;
				//svgDraw(svg, 
				let text = svgDraw(svg, "text", {"x":10, 
												"y":uy, 
												"fill":"#000000",
												'alignment-baseline': 'hanging',
												'font-size': "15px",
												"text-anchor":"start",
												});
				text.textContent = "(" + this.uniprotInfoData[uniprot_name]["length"] + " AA)";
				
				/*var text = document.createElementNS(svgns, 'text');
				text.setAttributeNS(null, 'x', x);
				text.setAttributeNS(null, 'y', y);
				text.setAttributeNS(null, 'fill', c);
				text.setAttributeNS(null, 'font-size', "12px");
				text.setAttributeNS(null, 'alignment-baseline', 'hanging');
				text.textContent = t;
				
				svgDrawText(svg, 0, uy, this.uniprotColorMap[uniprot_name], this.uniprotInfoData[uniprot_name]["length"] + " AA");*/
			});
			
			
			Object.entries(uniprot_backbone_rects).forEach(([uniprot_name, rs]) => {
				rs.forEach(r => {
					/*console.log(uniprot_name);
					console.log(r.w);
					*/
					snapshot_uniprot_backbones[uniprot_name] = svgDrawRect(svg, r.x, r.y, r.w, r.h, r.c);
					/*
					svgDrawLine(svg, r.x, r.y + backbone_height, r.x, r.y - backbone_ball_height, r.c, 1, null)
					svgDrawLine(svg, r.x, r.y - backbone_ball_height, r.x + 5, r.y - backbone_ball_height, r.c, 1, null)
					svgDrawText(svg, r.x, r.y - backbone_ball_height, r.c, max_mutation_frequency)
					*/
				});
			});
			
			vm.snapshot_uniprot_backbones = snapshot_uniprot_backbones;
			// the uniprot residue setting
			
			vm.availableUniprotResidues.forEach(uniprot_residue => {
				let uniprot_name, uniprot_pos;
				[uniprot_name, uniprot_pos] = uniprot_residue.split("_");
				let raw_mut_freq = this.cluster_data_dict[this.selectedCluster]["Mutation_frequency"][uniprot_residue]
				let mut_freq = raw_mut_freq > max_mut_freq_lim ? max_mut_freq_lim : raw_mut_freq;
					
				let x = text_width + (uniprot_pos - 1) * 1.0 / max_protein_length * draw_width + protein_snapshot_residue_radius;
				let y = uniprot_y[uniprot_name] - mut_freq / max_mutation_frequency * backbone_ball_height;
				
				// line below ball
				svgDrawLine(svg, x, y, x, uniprot_y[uniprot_name], "black", 1, null);
				
				if (raw_mut_freq > mut_freq) {
					// Additional slash line
					svgDrawLine(svg, x-protein_snapshot_residue_radius, (uniprot_y[uniprot_name] + y) / 2.1, x+protein_snapshot_residue_radius, (uniprot_y[uniprot_name] + y) / 1.9, "black", 1, null);
					// svgDrawLine(svg, x-protein_snapshot_residue_radius, (uniprot_y[uniprot_name] + y) / 2.1, x+protein_snapshot_residue_radius, (uniprot_y[uniprot_name] + y) / 1.9, "black", 1, null);
				}
				let circ = svgDrawCircle(svg, 
									x, 
									y,
									protein_snapshot_residue_radius, 
									this.unselected_uniprot_color);
				var svgns = "http://www.w3.org/2000/svg";
				// let title = document.createElementNS(svgns, 'title');
				// title.textContent = "Mutation count: " + raw_mut_freq.toString();//JSON Object
				// circ.appendChild(title);
									
				circ.addEventListener("mousemove", function(e) {
					console.log(e.pageX)
					vm.selectedMousePosition = [e.pageX, e.pageY]
					vm.selectedUniprotResidues = [uniprot_residue];
					
				});
				circ.addEventListener("mouseout", function(e) {
					vm.selectedUniprotResidues = [];
					vm.selectedMousePosition = [];
				});
				snapshot_uniprot_residues[uniprot_residue] = circ;
																			
			});
		
		

		},
		updateFunctionalPlot() {
			if (!this.module_data_dict)
				return;
			if (Object.keys(this.module_data_dict).length === 0)
				return;
			let svg = document.getElementById("functional_plot_svg");
			if (svg == null)
				return;
			let svgClear = function(svg) {
				while (svg.lastChild) {
					svg.removeChild(svg.lastChild);
				}
			}
			let svgDraw = function(svg, element, attributes){
				var svgns = "http://www.w3.org/2000/svg";
				var e = document.createElementNS(svgns, element);
				for (const [key, value] of Object.entries(attributes)) {
					e.setAttributeNS(null, key, value);
				}
				svg.appendChild(e);
				return e;
			}
			let svgDrawCircle = function(svg, x, y, r, c, stroke) {
				var svgns = "http://www.w3.org/2000/svg";
				var circ = document.createElementNS(svgns, 'circle');
				circ.setAttributeNS(null, 'cx', x);
				circ.setAttributeNS(null, 'cy', y);
				circ.setAttributeNS(null, 'r', r);
				circ.setAttributeNS(null, 'fill', c);
				svg.appendChild(circ);
				return circ;
			}
			let svgDrawLine = function(svg, x1, y1, x2, y2, c, sw, tooltip) {
				var svgns = "http://www.w3.org/2000/svg";
				var line = document.createElementNS(svgns, 'line');
				line.setAttributeNS(null, 'x1', x1);
				line.setAttributeNS(null, 'x2', x2);
				line.setAttributeNS(null, 'y1', y1);
				line.setAttributeNS(null, 'y2', y2);
				line.setAttributeNS(null, 'stroke', c);
				line.setAttributeNS(null, 'stroke-width', sw);
				
				var title = document.createElementNS(svgns, 'title');
				title.textContent = tooltip;//JSON Object
				line.appendChild(title);
				svg.appendChild(line);
				return line;
			}
			let svgDrawText = function(svg, x, y, c, t, fs) {
				var svgns = "http://www.w3.org/2000/svg";
				var text = document.createElementNS(svgns, 'text');
				text.setAttributeNS(null, 'x', x);
				text.setAttributeNS(null, 'y', y);
				text.setAttributeNS(null, 'fill', c);
				text.setAttributeNS(null, 'font-size', fs);
				text.setAttributeNS(null, 'alignment-baseline', 'middle');
				text.setAttributeNS(null, 'text-anchor', 'middle');
				
				text.textContent = t;
				svg.appendChild(text);
				return text;
			}
			let svgDrawArc = function(svg, x1, y1, x2, y2, large_arc_flag, radius, c, sw) {
				var svgns = "http://www.w3.org/2000/svg";
				var path = document.createElementNS(svgns, 'path');
				console.log(x1, y1, x2, y2, large_arc_flag, radius, c, sw);
				path.setAttributeNS(null, 'd', `M ${x1} ${y1} A ${radius} ${radius} 0 ${large_arc_flag} 1 ${x2} ${y2}`);
				path.setAttributeNS(null, 'stroke', c);
				path.setAttributeNS(null, 'stroke-width', sw);
				path.setAttributeNS(null, 'fill', "transparent");
				svg.appendChild(path);

				return path;
			}
			let getStarPoints = function(cx, cy, r1, r2) {
				let inner = [0,72,144,216,288].map(theta=>`${cx+r1*Math.cos(theta * Math.PI / 180)},${cy+r1*Math.sin(theta * Math.PI / 180)}`)
				let outer = [324,36,108,180,252].map(theta=>`${cx+r2*Math.cos(theta * Math.PI / 180)},${cy+r2*Math.sin(theta * Math.PI / 180)}`)
				let result = []
				for (let i = 0; i < 5; i++) {
					result.push(outer[i], inner[i]);
				}	
				return result.join(" ")
			}
			
			let vm = this;
			// Given the client width and height, fit the circle to the minimum
			let ww = Object.keys(vm.module_data_dict["functional"]["node"]).length * 25;
			if (ww < 400)
				ww = 400;
			svg.setAttribute("height", ww); 
			svg.setAttribute("width", ww); 
			let svgWidth = ww;
			svg.setAttribute("viewBox", `0 0 ${svgWidth} ${svgWidth}`); 
			
			
			// The following factors represent the relative distance from the center
			let nodeFactor = 0.7;
			let nodeFontSize = '12px';
			let selfLoopFactor = nodeFactor + 0.05;
			let nodeTextFactor = 0.9;
			let nodeRadius = 15;
			let mutRadius = 5;
			let functional_plot_nonkcg_color = "black"
			let functional_plot_kcg_color = "yellow"
			let functional_plot_query_color = "#67AFFF"
			
			let coor_mod = function(p, svgWidth) {
				return (p + 1) / 2 * svgWidth
			}
			console.log(coor_mod(-1, svgWidth), coor_mod(0, svgWidth), coor_mod(1, svgWidth))
			svgClear(svg);
			
			let circs = [];
			let edges = [];
			let cdn = this.module_data_dict["functional"]["node"];
			let cde = this.module_data_dict["functional"]["edge"];
			
			// Edge
			for (let [n1, n2, data] of cde) {
				// self loop
				if (n1 == n2) { 
					let vv = nodeRadius / Math.sqrt(cdn[n1][0] * cdn[n1][0] + cdn[n1][1] * cdn[n1][1]);
					svgDraw(svg, "circle", {"cx":coor_mod(cdn[n1][0] * nodeFactor, svgWidth) + vv * cdn[n1][0],
											"cy":coor_mod(cdn[n1][1] * nodeFactor, svgWidth) + vv * cdn[n1][1],
											"r": nodeRadius,  
											"fill":"none", 
											"stroke":"black",
											"stroke-width":1,
											});
				}
				else {
					//let line = svgDrawLine(svg, , , , this.circular_plot_edge_color, 1, `${n1},${n2}`);
					let line = svgDraw(svg, "line", {"x1": coor_mod(cdn[n1][0] * nodeFactor, svgWidth),
													"y1": coor_mod(cdn[n1][1] * nodeFactor, svgWidth),
													"x2": coor_mod(cdn[n2][0] * nodeFactor, svgWidth), 
													"y2": coor_mod(cdn[n2][1] * nodeFactor, svgWidth),
													"stroke": this.circular_plot_edge_color,
													"stroke-width": 1});
											/*		 
					if ("Signatures" in data) {
						let circ2 = svgDrawCircle(svg, (coor_mod(cdn[n1][0] * nodeFactor, svgWidth) + coor_mod(cdn[n2][0] * nodeFactor, svgWidth)) / 2, 
														(coor_mod(cdn[n1][1] * nodeFactor, svgWidth) + coor_mod(cdn[n2][1] * nodeFactor, svgWidth)) / 2,
														mutRadius, "red");
						circ2.addEventListener("mousemove", function(e) {
							let a = data["Signatures"].split(",").map(s => s.split("|"))
							vm.module_target_table = a;
						});
						circ2.addEventListener("mouseout", function(e) {
							vm.module_target_table = null;
						});
					}*/
				}
			}
			
			// Node
			for (let key in cdn) {
				let [circx, circy, data] = cdn[key];
				//let circ = svgDrawCircle(svg, coor_mod(circx * nodeFactor, svgWidth), coor_mod(circy * nodeFactor, svgWidth), nodeRadius, data["KCG"]?functional_plot_kcg_color:functional_plot_nonkcg_color );
				let circ = svgDrawCircle(svg, coor_mod(circx * nodeFactor, svgWidth), coor_mod(circy * nodeFactor, svgWidth), nodeRadius, vm.query_uniprots.includes(key)?functional_plot_query_color:functional_plot_nonkcg_color );
				//svgDrawText(svg, coor_mod(circx * nodeTextFactor, svgWidth), coor_mod(circy * nodeTextFactor, svgWidth), "black", key.split("_")[1], nodeFontSize);
				let vv = 2.5*nodeRadius / Math.sqrt(circx * circx + circy * circy);
				let additional = (vv / 1/2*nodeRadius)
				let text = svgDraw(svg, "text", {"fill":"black",
												"text-anchor":"middle",
												"font-size":nodeFontSize,
												"transform":`translate(${coor_mod(circx * nodeFactor, svgWidth)+circx * vv},${coor_mod(circy * nodeFactor, svgWidth)+circy * vv}) rotate(${Math.atan(circy/circx) / 3.141592654 * 180+90 + (circx>=0?0:180) })`
												});
				text.textContent=key;	
			}
			
			let lof_stroke_width = 3;
			// Edge Signatures
			for (let [n1, n2, data] of cde) {
				
				if ("Signatures" in data) {
					let centerx;
					let centery;
					let r;
					if (n1 == n2) {
						let vv = nodeRadius / Math.sqrt(cdn[n1][0] * cdn[n1][0] + cdn[n1][1] * cdn[n1][1]) * 2;
						centerx = coor_mod(cdn[n1][0] * nodeFactor, svgWidth) + vv * cdn[n1][0];
						centery = coor_mod(cdn[n1][1] * nodeFactor, svgWidth) + vv * cdn[n1][1];
					}
					else {
						centerx = (coor_mod(cdn[n1][0] * nodeFactor, svgWidth) + coor_mod(cdn[n2][0] * nodeFactor, svgWidth)) / 2;
						centery = (coor_mod(cdn[n1][1] * nodeFactor, svgWidth) + coor_mod(cdn[n2][1] * nodeFactor, svgWidth)) / 2;
						r = mutRadius;
					}
					let sigElements;
					if (data["Signatures"].includes("LoF")) {
						sigElements = [svgDraw(svg, "line", {"x1":centerx - r , "y1":centery - r, "x2":centerx + r, "y2":centery + r, "stroke":"red", "stroke-width":lof_stroke_width}),
										svgDraw(svg, "line", {"x1":centerx - r , "y1":centery + r, "x2":centerx + r, "y2":centery - r, "stroke":"red", "stroke-width":lof_stroke_width})];
					}
					else {
						sigElements = [svgDraw(svg, "polyline", {"points":getStarPoints(centerx, centery, mutRadius, mutRadius * 2), "fill":"red"})];
						//sigElements = [svgDrawCircle(svg, centerx, centery, mutRadius, "red")];
					}
					sigElements.forEach(sigElement => {
						sigElement.addEventListener("mousemove", function(e) {
							let a = data["Signatures"].split(",").map(s => s.split("|"))
							vm.module_target_table = a;
							let ex = 0
							if (e.pageX > window.innerWidth / 2)
								ex = e.pageX - 400;
							else
								ex = e.pageX + 10
							vm.functional_table_style = "overflow:hidden; position: absolute; display: block; left:" +(ex) + "px; top: " + (e.pageY + 10) + "px",
							console.log(vm.functional_table_style)
						});
						sigElement.addEventListener("mouseout", function(e) {
							//vm.functional_table_style = "position: absolute; display: none;",
							vm.module_target_table = null;
						});
					});

				}
			}			
			// Node Signatures
			for (let key in cdn) {
				let [circx, circy, data] = cdn[key];
				
				if ("Signatures" in data) {
					let centerx = coor_mod(circx * nodeFactor, svgWidth);
					let centery = coor_mod(circy * nodeFactor, svgWidth);
					let r = mutRadius;
					
					let sigElements;
					if (data["Signatures"].includes("LoF")) {
						//sigElements = [svgDrawCircle(svg, coor_mod(circx * nodeFactor, svgWidth), coor_mod(circy * nodeFactor, svgWidth), svgWidth / 100, "red")];
						sigElements = [svgDraw(svg, "line", {"x1":centerx - r , "y1":centery - r, "x2":centerx + r, "y2":centery + r, "stroke":"red", "stroke-width":lof_stroke_width}),
										svgDraw(svg, "line", {"x1":centerx - r , "y1":centery + r, "x2":centerx + r, "y2":centery - r, "stroke":"red", "stroke-width":lof_stroke_width})];
					}
					else {
						//sigElements = [svgDrawCircle(svg, coor_mod(circx * nodeFactor, svgWidth), coor_mod(circy * nodeFactor, svgWidth), mutRadius, "red")];
						sigElements = [svgDraw(svg, "polyline", {"points":getStarPoints(coor_mod(circx * nodeFactor, svgWidth), coor_mod(circy * nodeFactor, svgWidth), mutRadius, mutRadius*2), "fill":"red"})];
					}
					sigElements.forEach(sigElement => {
						sigElement.addEventListener("mousemove", function(e) {
							let a = data["Signatures"].split(",").map(s => s.split("|"))
							vm.module_target_table = a;
							let ex = 0
							if (e.pageX > window.innerWidth / 2)
								ex = e.pageX - 400;
							else
								ex = e.pageX + 10
							vm.functional_table_style = "overflow:hidden; position: absolute; display: block; left:" +(ex) + "px; top: " + (e.pageY + 10) + "px"
							
						});
						sigElement.addEventListener("mouseout", function(e) {
							vm.module_target_table = null;
						});
					});
				}
				
				
			}
				

			//}
			
		},
		updateDiffusionPlot() {
			let a = 1;
			if (a + 1 == 2)
				return;
			if (Object.keys(this.module_data_dict).length === 0)
				return;
			let svg = document.getElementById("diffusion_plot_svg");
			if (svg == null)
				return;
			
			let svgClear = function(svg) {
				while (svg.lastChild) {
					svg.removeChild(svg.lastChild);
				}
			}
			let svgDraw = function(svg, element, attributes){
				var svgns = "http://www.w3.org/2000/svg";
				var e = document.createElementNS(svgns, element);
				for (const [key, value] of Object.entries(attributes)) {
					e.setAttributeNS(null, key, value);
				}
				svg.appendChild(e);
				return e;
			}
			let svgDrawLine = function(svg, x1, y1, x2, y2, c, sw, tooltip) {
				var svgns = "http://www.w3.org/2000/svg";
				var line = document.createElementNS(svgns, 'line');
				line.setAttributeNS(null, 'x1', x1);
				line.setAttributeNS(null, 'x2', x2);
				line.setAttributeNS(null, 'y1', y1);
				line.setAttributeNS(null, 'y2', y2);
				line.setAttributeNS(null, 'stroke', c);
				line.setAttributeNS(null, 'stroke-width', sw);
				
				var title = document.createElementNS(svgns, 'title');
				title.textContent = tooltip;//JSON Object
				line.appendChild(title);
				svg.appendChild(line);
				return line;
			}
			
			let vm = this;
			let svgWidth = svg.clientWidth;
			let arcWidth = 10;
			let nodeFactor = 0.8;
			let nodeFactor2 = 0.7;
			let nodeTextFactor = 1;
			let arcFactor = 1.2;
			let arcTextFactor = 1.4;
			let nodeFontSize = '14px';
			let arcFontSize = '15px';
			let selfLoopFactor = 0.9;
			
			let functional_plot_nonkcg_color = "black"
			let functional_plot_kcg_color = "yellow"
			
			svgWidth = 300
			let coor_mod = function(p, svgWidth) {
				return (p + 1) / 2 * .5 * svgWidth + svgWidth *.25
			}
			
			svgClear(svg);
			var svgns = "http://www.w3.org/2000/svg";
			var defs = document.createElementNS(svgns, 'defs');
			var marker = document.createElementNS(svgns, 'marker');
			for (const [key, value] of Object.entries({"id":"arrowhead", "orient":"auto", "markerWidth":"3", "markerHeight":"4", "refX":"0.5", "refY":"2"})) {
				marker.setAttributeNS(null, key, value);
			}
			var path = document.createElementNS(svgns, 'path');
			for (const [key, value] of Object.entries({"d":"M0,0 V4 L2,2 Z", "class":"diffusion-edge-arrowhead"})) {
				path.setAttributeNS(null, key, value);
			}
			marker.append(path);
			defs.append(marker);
			svg.append(defs)
			
			//if (this.cluster_data_dict[this.selectedCluster]["Structure_source"] == "PDB") {
				let circs = [];
				let edges = [];
				let cdn = this.module_data_dict["diffusion"]["node"];
				let cde = this.module_data_dict["diffusion"]["edge"];

				// Edge
				for (let [n1, n2, data] of cde) {
					if (n1 == n2) {
						console.log("Stupid");
					}
					else {
						
						let x1 = cdn[n1][0];
						let y1 = cdn[n1][1];
						let x2 = cdn[n2][0];
						let y2 = cdn[n2][1];
						let net_x = x2 - x1;
						let net_y = y2 - y1;
						// update
						let f2 = 0.1;
						
						let factor = Math.sqrt(net_x * net_x + net_y * net_y);
						x1 = x1 + net_x / factor * .2
						y1 = y1 + net_y / factor * .2
						x2 = x2 - net_x / factor * .2
						y2 = y2 - net_y / factor * .2
						let [mod_x, mod_y] = [-net_y / factor * .075, net_x / factor * .075];
						// mod_x = 0;
						// mod_y = 0;
						/*if (x1 > x2) {
							[mod_x, mod_y] = [-net_y, net_x];
							console.log("A");
							console.log(mod_x, mod_y);
						}
						else {
							[mod_x, mod_y] = [net_y, -net_x];
							console.log("B");
							console.log(mod_x, mod_y);
						}
						*/
/*
						    <defs>
      <marker id='head' orient="auto"
        markerWidth='3' markerHeight='4'
        refX='0.1' refY='2'>
        <path d='M0,0 V4 L2,2 Z' fill="black"/>
      </marker>
    </defs>
*/
						let line = svgDraw(svg, "line", {"class":"diffusionEdgeClass",
														"x1":coor_mod((x1 + mod_x) * nodeFactor, svgWidth),
														"y1":coor_mod((y1 + mod_y) * nodeFactor, svgWidth), 
														"x2":coor_mod((x2 + mod_x) * nodeFactor, svgWidth), 
														"y2":coor_mod((y2 + mod_y) * nodeFactor, svgWidth), 
														"stroke-width":1,
														"marker-end":"url(#arrowhead)",
														
														});
						
						if ("Signatures" in data) {
						/*
							let circ2 = svgDrawCircle(svg, (coor_mod(cdn[n1][0] * nodeFactor, svgWidth) + coor_mod(cdn[n2][0] * nodeFactor, svgWidth)) / 2, 
															(coor_mod(cdn[n1][1] * nodeFactor, svgWidth) + coor_mod(cdn[n2][1] * nodeFactor, svgWidth)) / 2,
															svgWidth / 100, "red");
							circ2.addEventListener("mousemove", function(e) {
								let a = data["Signatures"].split(",").map(s => s.split("|"))
								vm.module_target_table = a;
							});
							circ2.addEventListener("mouseout", function(e) {
								vm.module_target_table = null;
							});
							*/
						}
					}
				}
				
				// Node
				for (let key in cdn) {
					let [circx, circy, data] = cdn[key];
					let circ = svgDraw(svg, "circle", {"cx":coor_mod(circx * nodeFactor, svgWidth), 
											"cy":coor_mod(circy * nodeFactor, svgWidth), 
											"r":svgWidth / 50, 
											"class":data["KCG"]?"diffusion-node-kcg-class":"diffusion-node-nonkcg-class",} );
					let text = svgDraw(svg, "text", {//"x":coor_mod(circx * nodeTextFactor, svgWidth), 
													//"y":coor_mod(circy * nodeTextFactor, svgWidth), 
													"fill":"black",
													"text-anchor":"middle",
													"transform":`translate(${coor_mod(circx * nodeTextFactor, svgWidth)},${coor_mod(circy * nodeTextFactor, svgWidth)}) rotate(${Math.atan(circy/circx) / 3.141592654 * 180+90 + (circx>=0?0:180) })`
													});
					text.textContent=key;
/*				text.setAttributeNS(null, 'font-size', fs);
				text.setAttributeNS(null, 'alignment-baseline', 'middle');
				text.setAttributeNS(null, 'text-anchor', 'middle');*/
											
					// svgDrawText(svg, coor_mod(circx * nodeTextFactor, svgWidth), coor_mod(circy * nodeTextFactor, svgWidth), "black", key.split("_")[1], nodeFontSize);
					// this.circular_plot_elements[key] = circ;
					/*
					if ("Signatures" in data) {
						let circ2 = svgDrawCircle(svg, coor_mod(circx * nodeFactor, svgWidth), coor_mod(circy * nodeFactor, svgWidth), svgWidth / 100, "red");
						circ2.addEventListener("mousemove", function(e) {
							let a = data["Signatures"].split(",").map(s => s.split("|"))
							console.log(a);
							vm.module_target_table = a;
						});
						circ2.addEventListener("mouseout", function(e) {
							vm.module_target_table = null;
						});
					}*/
					
				}
				

		},
		updateLegendPlot() {
			let svg = document.getElementById("legend_svg");
			if (svg == null)
				return;
			
			let svgClear = function(svg) {
				while (svg.lastChild) {
					svg.removeChild(svg.lastChild);
				}
			}
			let svgDraw = function(svg, element, attributes){
				var svgns = "http://www.w3.org/2000/svg";
				var e = document.createElementNS(svgns, element);
				for (const [key, value] of Object.entries(attributes)) {
					e.setAttributeNS(null, key, value);
				}
				svg.appendChild(e);
				return e;
			}
			let getStarPoints = function(cx, cy, r1, r2) {
				let inner = [0,72,144,216,288].map(theta=>`${cx+r1*Math.cos(theta * Math.PI / 180)},${cy+r1*Math.sin(theta * Math.PI / 180)}`)
				let outer = [324,36,108,180,252].map(theta=>`${cx+r2*Math.cos(theta * Math.PI / 180)},${cy+r2*Math.sin(theta * Math.PI / 180)}`)
				let result = []
				for (let i = 0; i < 5; i++) {
					result.push(outer[i], inner[i]);
				}	
				return result.join(" ")
			}
			let svgWidth = svg.clientWidth;
			let svgHeight = svg.clientHeight;
			svgWidth = 1000
			svgHeight = 50
			let radius = 5
			let r1 = 5
			let r2 = 10
			
			svgDraw(svg, "polyline", {"points":getStarPoints(svgWidth * 0.1, svgHeight * 0.5, r1, r2), "fill":"red"})
			//svgDraw(svg, "circle", {"cx": svgWidth * 0.1, "cy": svgHeight * 0.5, "r": radius, "fill":"red"});
			let text = svgDraw(svg, "text", {"x": svgWidth * 0.1 + radius * 4, 
											"y": svgHeight * 0.5, 
											"fill":"black",
											"text-anchor":"left",
											"alignment-baseline":"middle"
											});
			text.textContent="3D cluster";
			
			// svgDraw(svg, "circle", {"cx": svgWidth * 0.1, "cy": svgHeight * 0.4, "r": svgHeight * 0.05, "fill":"red"});
			let centerx = svgWidth * 0.3;
			let centery = svgHeight * 0.5;
			let r = 5;
			//<polygon points="100,10 40,180 190,60 10,60 160,180" fill="blue"/>
			svgDraw(svg, "line", {"x1":centerx - r , "y1":centery - r, "x2":centerx + r, "y2":centery + r, "stroke":"red", "stroke-width":5});
			svgDraw(svg, "line", {"x1":centerx - r , "y1":centery + r, "x2":centerx + r, "y2":centery - r, "stroke":"red", "stroke-width":5});
			let text2 = svgDraw(svg, "text", {"x": svgWidth*0.3 + r * 4, 
											"y": centery, 
											"fill":"black",
											"text-anchor":"left",
											"alignment-baseline":"middle"
											});
			text2.textContent="LOF enrichment signal";
		},
		setURLRequest(pdbClusterName) {
			// get graph data for charts and tables
			//let path = "http://localhost:5000/protein/" + pdbClusterName;
			let path = "http://netflow3dapi.yulab.org/protein/" + pdbClusterName;
			axios.get(path).then((res) => {

				this.isLoading = false;
				this.setURL(res.data.name);
			});
		},
		setURL(url) {
			this.isLoading = false;
			this.$router.push({
				path: "/advanced/" + url,
			});
		},
		toggleScreen() {
			this.stage.toggleFullscreen();
		},
		handleResize() {
			console.log("which time handle resize")
			//this.stage.handleResize();
			this.updateProteinSnapshots();
		},
		exportMutationResTable(){
			
			var downloadLink;
			var dataType = 'application/vnd.ms-excel';
			var csvContent = "data:text;charset=utf-8,";
			
			var tableHTML = csvContent;
			tableHTML = tableHTML + this.cluster_data_dict[this.selectedCluster]["mutation_resource"]
			var filename = this.selectedCluster + "_Mutations.txt";
			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);
			
			if(navigator.msSaveOrOpenBlob){
			var blob = new Blob(['\ufeff', tableHTML], {
			type: dataType
			});
			navigator.msSaveOrOpenBlob( blob, filename);
			}else{
			// Create a link to the file
			downloadLink.href = tableHTML;

			// Setting the file name
			downloadLink.download = filename;

			//triggering the function
			downloadLink.click();
			}
		},
		
		/*
		exportTableToExcel(tableID, filename = ''){
			var downloadLink;
			var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename?filename+'.xls':'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if(navigator.msSaveOrOpenBlob){
			var blob = new Blob(['\ufeff', tableHTML], {
			type: dataType
			});
			navigator.msSaveOrOpenBlob( blob, filename);
			}else{
			// Create a link to the file
			downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

			// Setting the file name
			downloadLink.download = filename;

			//triggering the function
			downloadLink.click();
			}
		},*/
		

	},
};
</script>

